import { render, staticRenderFns } from "./suspiciousCustomer.vue?vue&type=template&id=503f55ea&scoped=true"
import script from "./suspiciousCustomer.vue?vue&type=script&lang=js"
export * from "./suspiciousCustomer.vue?vue&type=script&lang=js"
import style0 from "./suspiciousCustomer.vue?vue&type=style&index=0&id=503f55ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503f55ea",
  null
  
)

export default component.exports